var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5L15 5.5H10V0.5ZM11.25 10.5V13H3.75V10.5H11.25ZM8.75 5.5C8.75 6.20312 9.29688 6.75 10 6.75H15V18.625C15 19.6797 14.1406 20.5 13.125 20.5H1.875C0.820312 20.5 0 19.6797 0 18.625V2.375C0 1.35938 0.820312 0.5 1.875 0.5H8.75V5.5ZM2.5 3.3125V3.9375C2.5 4.13281 2.61719 4.25 2.8125 4.25H5.9375C6.09375 4.25 6.25 4.13281 6.25 3.9375V3.3125C6.25 3.15625 6.09375 3 5.9375 3H2.8125C2.61719 3 2.5 3.15625 2.5 3.3125ZM2.5 5.8125V6.4375C2.5 6.63281 2.61719 6.75 2.8125 6.75H5.9375C6.09375 6.75 6.25 6.63281 6.25 6.4375V5.8125C6.25 5.65625 6.09375 5.5 5.9375 5.5H2.8125C2.61719 5.5 2.5 5.65625 2.5 5.8125ZM12.5 17.6875V17.0625C12.5 16.9062 12.3438 16.75 12.1875 16.75H9.0625C8.86719 16.75 8.75 16.9062 8.75 17.0625V17.6875C8.75 17.8828 8.86719 18 9.0625 18H12.1875C12.3438 18 12.5 17.8828 12.5 17.6875ZM12.5 9.875C12.5 9.5625 12.1875 9.25 11.875 9.25H3.125C2.77344 9.25 2.5 9.5625 2.5 9.875V13.625C2.5 13.9766 2.77344 14.25 3.125 14.25H11.875C12.1875 14.25 12.5 13.9766 12.5 13.625V9.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b83922cef3bb9b8dcf6bdcc99deeabb1.svg";
export { ForwardRef as ReactComponent };